import React from 'react'
import {observer} from 'mobx-react'
import {useTranslation} from 'react-i18next'
import {LinksProps} from './props'
import styles from './styles.scss'
import {urls} from '@/constants/urls'
import {COOKIES_POLICY} from '@/constants/playwright-ids'

export const Links: React.FC<LinksProps> = observer(({onCookiesClick}) => {
    const {t} = useTranslation()
    return (
        <div className={styles.links}>
            <a href={'#'} onClick={onCookiesClick} data-test-id={COOKIES_POLICY}>
                {t('Links.cookies')}
            </a>
            <a href={urls.privacyPolicy} target={'_blank'} rel='noreferrer'>
                {t('Links.privacyPolicy')}
            </a>
            <a href={urls.termsUse} target={'_blank'} rel='noreferrer'>
                {t('Links.termsAndConditions')}
            </a>
        </div>
    )
})
